import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useRef } from "react";


const formatPrice = (value) => {
    const num = Number(value);
    if (isNaN(num) || num <= 0) return 'N/A';

    if (num >= 1e7) {
        return `${(num / 1e7).toFixed(2)} Crore`;
    } else if (num >= 1e5) {
        return `${(num / 1e5).toFixed(2)} Lakh`;
    } else {
        return num.toLocaleString('en-IN'); // fallback for values < 1 Lakh
    }
};

const getPriceAndAreaDetails = (flatTypeArray) => {
    let smallest = null;
    let largest = null;

    flatTypeArray.forEach(ft => {
        if (Array.isArray(ft.builtUpAreas)) {
            ft.builtUpAreas.forEach(area => {
                const price = parseFloat(area.expectedPrice || 0);
                if (!isNaN(price) && price > 0) {
                    if (!smallest || price < parseFloat(smallest.expectedPrice)) smallest = area;
                    if (!largest || price > parseFloat(largest.expectedPrice)) largest = area;
                }
            });
        }
    });

    return { smallest, largest };
};

const MyProperty = () => {
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const [imageIndexes, setImageIndexes] = useState([]);
    const location = useLocation();
    const inputRef = useRef(null);
    const [propertyFilter, setPropertyFilter] = useState("All");


    useEffect(() => {
        if (location.state?.focusSearch && inputRef.current) {
            inputRef.current.focus({ preventScroll: true });
        }
    }, [location.state]);



    useEffect(() => {
        setImageIndexes(new Array(data.length).fill(0));
    }, [data]);


    const BASE_URL = process.env.REACT_APP_LINK;

    const fetchAll = async () => {
        try {
            const [res1, res2, res3] = await Promise.all([
                fetch(`${BASE_URL}/resident/getproperty/HBTR0001`),
                fetch(`${BASE_URL}/commercial/getproperty/HBTR0001`),
                fetch(`${BASE_URL}/rentresident/getproperty/HBTR0001`)
            ]);

            const [json1, json2, json3] = await Promise.all([
                res1.json(),
                res2.json(),
                res3.json()
            ]);

            const parseProps = (item) => {
                const parseJSON = (val) => {
                    try {
                        return typeof val === 'string' ? JSON.parse(val) : val;
                    } catch {
                        return val;
                    }
                };
                return {
                    amenities: parseJSON(item.amenities || "[]"),
                    carpetArea: parseJSON(item.carpetArea || "[]"),
                    flatType: parseJSON(item.flatType || "[]"),
                    expectedPrice: parseJSON(item.expectedPrice || "[]"),
                    formImages: parseJSON(item.formImages || "[]"),
                    locationAdvantage: parseJSON(item.locationAdvantage || item.locationAdvantages || "[]"),
                };
            };

            const combined = [
                ...json1.map(item => ({ ...item, type: "resident", ...parseProps(item) })),
                ...json2.map(item => ({ ...item, type: "commercial", ...parseProps(item) })),
                ...json3.map(item => ({ ...item, type: "rent", ...parseProps(item) }))
            ];

            const uniqueData = combined.filter(
                (value, index, self) =>
                    index === self.findIndex((t) => t.property_id === value.property_id)
            );

            const sortedData = uniqueData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setData(sortedData);
        } catch (error) {
            console.log("Error loading data:", error);
        }
    };

    useEffect(() => {
        fetchAll();
    }, []);

    const handlePageChange = (propertyId, propertType) => {
        if (propertType === "Residential") {
            navigate(`/residential-property/${propertyId}`);
        } else if (propertType === "Commercial") {
            navigate(`/commercial-property/${propertyId}`);
        } else if (propertType === "Rent Residential") {
            navigate(`/rent-property/${propertyId}`);
        }
    };

    // const filteredData = data.filter((card) => {
    //     const search = searchTerm.toLowerCase();

    //     const bhks = card.flatType
    //         .map(ft => {
    //             if (ft.bedrooms === "jodi") {
    //                 const jodi1 = parseInt(ft.jodi1) || 0;
    //                 const jodi2 = parseInt(ft.jodi2) || 0;
    //                 return `${jodi1 + jodi2}BHK`;
    //             } else if (ft.bedrooms && !isNaN(ft.bedrooms)) {
    //                 return `${ft.bedrooms}BHK`;
    //             } else {
    //                 return ft.type;
    //             }
    //         })
    //         .join(", ");

    //     const carpetAreas = (card.flatType || [])
    //         .flatMap(ft => (ft.builtUpAreas || []).map(area => area.value))
    //         .filter(Boolean)
    //         .join(", ");

    //     const priceList = (card.flatType || [])
    //         .flatMap(ft => (ft.builtUpAreas || []).map(area => area.expectedPrice))
    //         .filter(Boolean)
    //         .join(", ");

    //     const searchableString = `
    //     ${card.building_name || ""}
    //     ${card.address || ""}
    //     ${card.city || ""}
    //     ${bhks}
    //     ${carpetAreas}
    //     ${priceList}
    // `.toLowerCase();

    //     return searchableString.includes(search);
    // });
    const filteredData = data
        .filter((card) => {
            // ✅ Filter by dropdown first
            if (propertyFilter !== "All") {
                if (card.typeofproperty !== propertyFilter) {
                    return false;
                }
            }

            const search = searchTerm.toLowerCase();

            const bhks = card.flatType
                .map(ft => {
                    if (ft.bedrooms === "jodi") {
                        const jodi1 = parseInt(ft.jodi1) || 0;
                        const jodi2 = parseInt(ft.jodi2) || 0;
                        return `${jodi1 + jodi2}BHK`;
                    } else if (ft.bedrooms && !isNaN(ft.bedrooms)) {
                        return `${ft.bedrooms}BHK`;
                    } else {
                        return ft.type;
                    }
                })
                .join(", ");

            const carpetAreas = (card.flatType || [])
                .flatMap(ft => (ft.builtUpAreas || []).map(area => area.value))
                .filter(Boolean)
                .join(", ");

            const priceList = (card.flatType || [])
                .flatMap(ft => (ft.builtUpAreas || []).map(area => area.expectedPrice))
                .filter(Boolean)
                .join(", ");

            const searchableString = `
      ${card.building_name || ""}
      ${card.address || ""}
      ${card.city || ""}
      ${bhks}
      ${carpetAreas}
      ${priceList}
    `.toLowerCase();

            return searchableString.includes(search);
        });


    const formatCarpetAreas = (flatTypes = []) => {
        const areaSet = new Set();

        flatTypes.forEach(ft => {
            if (Array.isArray(ft.builtUpAreas)) {
                ft.builtUpAreas.forEach(areaObj => {
                    const area = parseFloat(areaObj?.value);
                    if (!isNaN(area)) {
                        areaSet.add(area);
                    }
                });
            }
        });

        const sortedAreas = [...areaSet].sort((a, b) => a - b);
        const areaString = sortedAreas.length > 0 ? `${sortedAreas.join(', ')} sqft` : '';

        // ✅ Trim to max 20 characters (add ellipsis if needed)
        return areaString.length > 20 ? areaString.slice(0, 17) + '...' : areaString;
    };




    return (
        <div className="properties-main-first-brick my-property-page-fb">
            <div className="property-section-heading-first-brick">
                <h1>Find Your Dream Home</h1>
                <p>Browse premium listings across top cities in India.</p>
            </div>

            <div className="real-estate-search-div responsive-search-bar">

                {/* SEARCH */}
                <div className="search-wrapper">
                    <input
                        ref={inputRef}
                        type="text"
                        placeholder="Search by name, city, address, or BHK..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input-real-estate"
                    />

                </div>
                <div style={{ marginLeft: "20px" }} className="filter-wrapper">
                    <select
                        value={propertyFilter}
                        onChange={(e) => setPropertyFilter(e.target.value)}
                        className="property-filter-select"
                    >
                        <option value="All">All</option>
                        <option value="Residential">Residential</option>
                        <option value="Commercial">Commercial</option>
                        {/* <option value="Rent Residential">Rent</option> */}
                    </select>
                </div>

                {/* FILTER */}


            </div>




            <div className="my-property-page-properties-fb">
                {filteredData.length === 0 ? (
                    <div className="no-properties-message" style={{ color: "#fff", textTransform: "capitalize", margin: "50px 10px" }}>
                        No properties available.
                    </div>
                ) : (
                    filteredData.map((card, idx) => {
                        const { smallest, largest } = getPriceAndAreaDetails(card.flatType);
                        return (
                            <div className="property-card-first-brick" key={card.property_id}>
                                <div className="ribbon">
                                    {card.typeofproperty?.charAt(0).toUpperCase() + card.typeofproperty?.slice(1).toLowerCase() || 'Property'}
                                </div>

                                <div className="property-card-images-first-brick">
                                    {card.formImages.slice(0, 3).map((img, i) => (
                                        <img
                                            key={i}
                                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}/Images/Store/${img}`}
                                            alt={`${card.building_name} view ${i + 1}`}
                                            style={{
                                                opacity: imageIndexes[idx] === i ? 1 : 0,
                                                transition: 'opacity 0.6s ease-in-out',
                                                zIndex: imageIndexes[idx] === i ? 2 : 1,
                                                position: 'absolute'
                                            }}
                                            onClick={() => handlePageChange(card.property_id, card.typeofproperty)}
                                        />
                                    ))}

                                    <div className="property-card-images-pagination-first-brick">
                                        {card.formImages.slice(0, 3).map((_, i) => (
                                            <span
                                                key={i}
                                                className={`dash ${imageIndexes[idx] === i ? 'active' : ''}`}
                                                onClick={() => {
                                                    const newIndexes = [...imageIndexes];
                                                    newIndexes[idx] = i;
                                                    setImageIndexes(newIndexes);
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            ></span>
                                        ))}
                                    </div>
                                </div>

                                <div className="property-card-content-first-brick">
                                    <div
                                        className="property-card-building-name-first-brick"
                                        onClick={() => handlePageChange(card.property_id, card.typeofproperty)}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <h1>{card.building_name}</h1>
                                    </div>

                                    {(smallest?.expectedPrice > 0 || largest?.expectedPrice > 0) && (
                                        <div className="property-card-pricing-first-brick">
                                            <h3>
                                                {smallest?.expectedPrice > 0 && largest?.expectedPrice > 0 ? (
                                                    smallest.expectedPrice === largest.expectedPrice ? (
                                                        `₹ ${formatPrice(smallest.expectedPrice)}`
                                                    ) : (
                                                        `₹ ${formatPrice(smallest.expectedPrice)} - ₹ ${formatPrice(largest.expectedPrice)}`
                                                    )
                                                ) : smallest?.expectedPrice > 0 ? (
                                                    `₹ ${formatPrice(smallest.expectedPrice)}`
                                                ) : (
                                                    `₹ ${formatPrice(largest.expectedPrice)}`
                                                )}
                                            </h3>
                                        </div>
                                    )}

                                    <div className="property-card-carpet-address-first-brick">
                                        <p>{formatCarpetAreas(card.flatType)} at {card.city}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default MyProperty;
